module.exports = __webpack_public_path__ + "e90d92ce0f7b92ad2eda7e69ba348d40.fbx";